import { getFirestore, doc, getDoc } from "firebase/firestore";

const db = getFirestore();

/**
 * Parsea un campo de Firestore con formato:
 * "Título@@URL@@Código@@Flags"
 */
function parseTema(rawValue) {
  if (!rawValue || typeof rawValue !== "string") {
    return { titulo: "", url: "", icono: "", flags: "" };
  }

  const [titulo, url, icono, flags] = rawValue.split("@@");
  return { titulo, url, icono, flags };
}

export async function getMateriaData(materiaId) {
  const cacheKey = `materia_${materiaId}`;
  const cache = sessionStorage.getItem(cacheKey);

  if (cache) {
    return JSON.parse(cache);
  }
  try {
    const ref = doc(db, "LaMatrix", materiaId);
    const snap = await getDoc(ref);

    if (!snap.exists()) {
      console.warn("No existe la materia:", materiaId);
      return {};
    }

    const data = snap.data(); // { a01: "...", a02: "...", ... }

    // Transformamos cada campo en objeto parseado
    const temas = Object.entries(data).map(([codigo, rawValue]) => {
      const parsed = parseTema(rawValue);
      return {
        ...parsed,
        codigo // clave del campo (ej. "a01")
      };
    });

    const materiaParsed = { id: materiaId, temas };

    // ✅ Guardar en caché
    sessionStorage.setItem(cacheKey, JSON.stringify(materiaParsed));

    return materiaParsed;
  } catch (error) {
    console.error("Error leyendo materia:", error);
    return {};
  }
}

export async function getEvaluacionTemaData(codigoTema) {
  try {
    //console.log("Tema recibido en getEvaluaciónTema: ", codigoTema);
    const docRef = doc(db, "Exercises COLBACH 2021", codigoTema);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return docSnap.data();
    } else {
      console.error("No existe el tema:", codigoTema);
      return null;
    }
  } catch (error) {
    console.error("Error al obtener tema:", error);
    return null;
  }
}